export const BUTTON_ICONS = {
  URL: 'i-lucide-external-link',
  PHONE_NUMBER: 'i-lucide-phone',
  COPY_CODE: 'i-lucide-copy',
  CATALOG: 'i-lucide-shopping-bag',
  FLOW: 'i-lucide-list',
  ORDER_DETAILS: 'i-lucide-receipt',
  VOICE_CALL: 'i-lucide-phone-call',
};
